import { DbLogoIcon } from '@repo/ui/icons'
import RouterLink from '@/components/common/RouterLink'
import OfflineIndicator from '@/features/offline/components/OfflineIndicator'
import { DarkModeButton } from '@repo/ui'
import ScrollProgressIndicator from '../../common/ScrollProgressIndicator'
import ZugnummerDisplay from '@/components/common/ZugnummerDisplay'
import RelevantBfnsDisplay from '@/components/common/RelevantBfnsDisplay'

export default function Header() {
  const testIdInit = 'header'

  return (
    <header
      className="sticky top-0 z-50 rea-header px-0 dark:bg-cool-gray-800 dark:shadow-none dark:border-b dark:border-cool-gray-200"
      role="banner"
      data-testid={testIdInit}
    >
      <div className="container flex justify-center items-center">
        <div className="flex flex-1 justify-between items-center text-center">
          <RouterLink
            to="/"
            title="Home"
            rel="home"
            data-testid={`${testIdInit}-logo-link`}
          >
            <DbLogoIcon
              width={40}
              height={28}
              data-testid={`${testIdInit}-logo-left`}
            />
          </RouterLink>
          <div className="flex flex-row gap-0.5">
            <ZugnummerDisplay data-testid={`${testIdInit}-zugnummer`} />
            <RelevantBfnsDisplay data-testid={`${testIdInit}-relevant-bfns`} />
          </div>
          <div className="flex justify-end items-center">
            <OfflineIndicator data-testid={`${testIdInit}-offline-indicator`} />
            <DarkModeButton />
          </div>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 h-[5px] w-full">
        <ScrollProgressIndicator
          data-testid={`${testIdInit}-scroll-progress-indicator`}
        />
      </div>
    </header>
  )
}
